import React, { useState, forwardRef, useEffect } from 'react'

const Input = (props, ref) => {
  const [state, setState] = useState({
    editing: false,
    [props.name]: props.value,
  })

  useEffect(() => {
    setState({
      ...state,
      [props.name]: props?.value,
    })
  }, [props.value])

  const handleInput = (e) => {
    const { name, value } = e.target
    setState({
      ...state,
      [name]: value,
      editing: true,
    })
    props.onChange(e)
  }

  const lengthCheck = (input) => {
    if (input.target.value.length > input.target.maxLength) {
      input.target.value = input.target.value.slice(0, input.target.maxLength)
    }
  }

  return (
    <React.Fragment>
      <div
        className={`input-wrapper ${props.wrapperClassName ? props.wrapperClassName : ''}`}
        style={props.wrapperClassWidth ? { width: 'inherit' } : {}}
      >
        {props.title ? (
          <label className="input-title">
            {props.title}
            {props.required ? <span className="required">*</span> : ''}
          </label>
        ) : (
          ''
        )}

        <div
          className={`${props.withBtn ? 'input-with-btn' : ''}`}
          tooltip={props.message}
          flow={props.flow}
          flag={`${props.required && props.submitted && !props.value ? 'show' : 'hidden'}`}
        >
          <input
            type={props.type}
            id={props.id}
            title={props?.inputTitle}
            name={props.name}
            value={state[props.name] ? state[props.name] : props.value}
            autoComplete={props.type == 'password' ? 'new-password' : 'off'}
            className={props.className}
            placeholder={props.placeholder}
            maxLength={props.length ? props.length : ''}
            onInput={(e) => (props.length ? lengthCheck(e) : '')}
            onChange={handleInput}
            readOnly={props.readOnly}
            ref={ref}
            style={props.withBtn ? { border: '1px solid #e1e2e6' } : {}}
          />

          {props.withBtn ? (
            <a href="#" title="새창 열림" className="btn-secondary sm cursor" onClick={() => props.withBtnClick()}>
              {props.withBtnName}
            </a>
          ) : (
            ''
          )}
        </div>
        {props.errMessage && (
          <div className="input-error">
            <label htmlFor={props.id} style={{ color: 'red' }}>
              {props.errMessage}
            </label>
          </div>
        )}

        {props.okMessage && (
          <div className="input-ok">
            <label htmlFor={props.id}>{props.okMessage}</label>
          </div>
        )}
      </div>
    </React.Fragment>
  )
}

export default forwardRef(Input)
